import '@firebase/auth-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/compat/auth/dist/index.esm.js
// module id = 160
// module chunks = 14